<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
html,
body {
    overflow: initial !important;
}
::-webkit-scrollbar {
    width: 5px!important;
    height: 5px!important;
}
/*滚动槽*/
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px transparent!important;
    border-radius: 10px!important;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 10px!important;
    background: rgb(20, 170, 255)!important;
    -webkit-box-shadow: inset 0 0 6px transparent!important;
}
::-webkit-scrollbar-thumb:window-inactive {
    background: transparent!important
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    /*color: #484a4d;*/
    /* background:  #b6bbbb21; */
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
}
.content {
    width: 1000px;
    margin: 0 auto;
}
body {
    padding: 0;
    margin: 0;
}
.ck-source-editing-area textarea {
    overflow: auto!important;
}
.ck-source-editing-area,
.ck-content {
    height: 450px;
}

.ck-content .table {
    width: 100%;
}

.call-wrap {
    position: fixed;
    right: 250px;
    top: 6px;
    z-index: 9999;
}
.call-root {background: #f5f7fa;padding: 0 10px;border-radius: 4px;}
</style>



// WEBPACK FOOTER //
// src/App.vue